<template>
    <div class="less-than-audit">
        <div class="title">零担自营线路审批</div>
        <SupBaseInfo
            v-if="baseInfoVisible"
            :supplierParams="supplierParams"
            :auditId="auditId"
            :moduleCode="moduleCode" />
        <RegularLineTable :ids="ids" v-if="baseInfoVisible" :supplierCode="supplierParams.supplierCode" :auditId="auditId" title="零担自营线路明细"/>
    </div>
</template>
<script>
import { selectByAuditId } from '../../../../../../api/regularRoute.js'
import SupBaseInfo from './SupBaseInfo.vue'
import RegularLineTable from './RegularLineTable.vue'
export default {
    components: { SupBaseInfo, RegularLineTable },
    props: {
        auditId: {
            type: String,
            default: '',
        },
        moduleCode: {
            type: String,
            default: '',
        },
        ids: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            // 供应商信息参数
            supplierParams: {
                id: '',
                businessType: '',
                supplierCode: '',
                propertyNature: '',
            },
            baseInfoVisible: false,
        }
    },
    methods: {
        setSupplierParams() {
            selectByAuditId({ auditId: this.auditId })
                .then(res => {
                    if (res && +res.code === 0) {
                        if (res.data) {
                            this.supplierParams.id = res.data.supplierInfoId
                            this.supplierParams.businessType = res.data.businessType
                            this.supplierParams.supplierCode = res.data.supplierCode
                            this.supplierParams.propertyNature = res.data.propertyNature
                        }
                        this.baseInfoVisible = true
                    }
                })
                .catch(err => {})
        },
    },
    mounted() {
        this.setSupplierParams()
    },
}
</script>
<style lang="less" scoped>
.less-than-audit {
    color: #000;

    .title {
        margin-bottom: 15px;
        font-size: 16px;
        font-weight: bold;
    }
}
</style>
